import * as React from 'react';
import { useDispatch } from 'react-redux';
import { Button } from 'primereact/button';
import { ContractorProjectDocActions } from '../../helpers/constants/modelActions/ContractorProjectDocActions';
import { useBackgroundPromiseWrapper } from '../../helpers/hooks/useBackgroundPromiseWrapper';
import { services } from '../../services';
import { alertSuccess } from '../../store/reducers/Alert';
import { ModelAction } from '../../types/responses/ModelAction';
import { CommentButton } from '../buttons/CommentButton';

interface PaperSigningActionsProps {
    projectDocId: number;
    onProjectDocStatusUpdated: () => void;
    actions: ModelAction[];
    loadActions: () => void;
    onPaperSigningGenerated?: () => void;
}

export const PaperSigningActions: React.FC<PaperSigningActionsProps> = ({
    projectDocId,
    onProjectDocStatusUpdated,
    actions,
    loadActions,
}) => {
    const dispatch = useDispatch();
    const [promiseWrapper, isLoading] = useBackgroundPromiseWrapper();

    const startPaperSigningApproval = React.useCallback(
        (comment: string) => {
            promiseWrapper(
                () => services.paperSigningService.startApproval(projectDocId),
                () => {
                    dispatch(alertSuccess({ detail: 'Отправлено на согласование' }));
                    onProjectDocStatusUpdated();
                    loadActions();
                },
            );
        },
        [projectDocId, onProjectDocStatusUpdated, loadActions],
    );

    return (
        <React.Fragment>
            {actions.some(a => a.Id === ContractorProjectDocActions.StartPaperSigningApproval) && (
                <CommentButton
                    label="Отправить на согласование"
                    className="mr-1"
                    icon=""
                    commentIsRequired={false}
                    disabled={isLoading}
                    action={startPaperSigningApproval}
                />
            )}
        </React.Fragment>
    );
};